import { isDesignDnaDemoPrompt } from '@/features/chat/demo/isDesignDnaDemoPrompt.js'
import {
  isDesignDnaProceedPrompt,
  threadAwaitingDesignDnaProceed,
} from '@/features/chat/demo/isDesignDnaProceedPrompt.js'
import { isAcmeInsuranceRenewalDemoPrompt } from '@/features/chat/demo/isAcmeInsuranceRenewalDemoPrompt.js'
import {
  isAcmeInsuranceRenewalMondayTriggerPrompt,
  threadAwaitingAcmeInsuranceRenewalMondayTrigger,
} from '@/features/chat/demo/isAcmeInsuranceRenewalMondayTriggerPrompt.js'
import { isSyntheticDataDemoPrompt } from '@/features/chat/demo/isSyntheticDataDemoPrompt.js'
import { runDesignDnaProceedDemoStream } from './runDesignDnaProceedDemoStream.js'
import { runDesignDnaDemoStream } from './runDesignDnaDemoStream.js'
import { runResponseComponentDemoStream } from './runResponseComponentDemoStream.js'
import { runAcmeInsuranceRenewalMondayTriggerStream } from './runAcmeInsuranceRenewalMondayTriggerStream.js'
import { runAcmeInsuranceRenewalDemoStream } from './runAcmeInsuranceRenewalDemoStream.js'
import { runSyntheticDataDemoStream } from './runSyntheticDataDemoStream.js'

export const DEMO_MATCHERS_PART02 = [
  {
    when: (q) =>
      isDesignDnaProceedPrompt(q.trimmed) && threadAwaitingDesignDnaProceed(q.priorMessages),
    run: runDesignDnaProceedDemoStream,
  },
  { when: (q) => isDesignDnaDemoPrompt(q.trimmed), run: runDesignDnaDemoStream },
  {
    when: (q) => q.allowResponseComponentDemo && q.trimmed.toLowerCase() === 'response component',
    run: runResponseComponentDemoStream,
  },
  {
    when: (q) =>
      isAcmeInsuranceRenewalMondayTriggerPrompt(q.trimmed) &&
      threadAwaitingAcmeInsuranceRenewalMondayTrigger(q.priorMessages),
    run: runAcmeInsuranceRenewalMondayTriggerStream,
  },
  { when: (q) => isAcmeInsuranceRenewalDemoPrompt(q.trimmed), run: runAcmeInsuranceRenewalDemoStream },
  { when: (q) => isSyntheticDataDemoPrompt(q.trimmed, q.files), run: runSyntheticDataDemoStream },
]
